<template>
  <ValidationProvider :vid="vid"
                      :mode="mode"
                      :name="String(_uid)"
                      :rules="rules"
                      v-slot="{ errors, valid }">
    <v-radio-group
      :class="customClass"
      v-model="innerValue"
      :error-messages="errors.length ? ['Je to povinné pole'] : []"
      v-bind="$attrs"
      v-on="$listeners"
      :row="row">
      <slot />
    </v-radio-group>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    // must be included in props
    value: {
      type: null,
      default: ''
    },
    row: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
    vid: {
      type: String,
      default: ''
    },
  },
  data: () => ({
    innerValue: ''
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
      if (this.innerValue === '0' || this.innerValue === 0) {
        this.innerValue = null;
      }
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
